import React, {} from "react";
import Footer from "../Components/Footer";



function LearnMore() {
  return (
    <div className="w-full h-screen  flex flex-col">
     
      <div className="px-32 pt-2   flex-1 flex justify-center ">
        <div className="w-2/3">
        <img className="my-8" alt="app icon" src={require("../images/icons/logo.png")} />
          <h1 className="font-bold text-2xl">About Ignite Connector:</h1>

          <p>Ignite Connector provides a platform for syncing QuickBooks Online with your Shopify store. You can automate the process by syncing your historical and future data with Ignite Connector. </p>

            <h1 className="mt-4 font-bold">Ignite Connector Sync you with:</h1>
          <ul className="list-disc pl-4">
            <li>Orders with QuickBooks Online</li>
            <li>Customers</li>
            <li>Payments</li>
            <li>Products</li>
            <li>Up to two months of QuickBooks Online historical data manually.</li>
          </ul>  

          <h1 className="mt-4 font-bold">Ignite Connector helps you track:</h1>
          <ul className="list-disc pl-4">
            <li>Your revenue, products, and orders, straight from QuickBooks Online Dashboard.</li>
            <li>Enable the automatic sync and let QuickBooks Online sync the future entries automatically.</li>
            <li>Evaluate your payments, revenue, and profits.</li>
            <li>In case of any query, our representatives are there for you at any moment.</li>
             
          </ul>  

          <p className="mt-4">Ignite connector helps you increase your E-commerce efficiency and productivity on QuickBooks Online. This is done by automating the time-consuming accounting task, extracting data from Shopify, and keeping track of every order.</p>

          <p className="mt-4">
          Log in to your Shopify Store and to use this feature add <span className="font-bold">"Ignite for QuickBooks Sync"</span> from the Shopify store.
          </p>
          <p className="mt-4">To avail of the amazing 30 days free trial, Install the “Ignite for QuickBooks Sync” in your Shopify store now. Contact us at
           <span className="font-bold px-1">support@kickstarthq.com</span>if you have any queries or want to request a demo.</p>
        </div>
      </div>
 
      <div className="bg-green-200 flex-none mt-10">
        <Footer/>
      </div>
    </div>
  );
}

export default LearnMore;
